<ul>
  <li>
    <p>
      <span
        ><span style="color: #00b0f0;"><span><span lang="en-GB"><strong>Target</strong></span></span></span><span style="color: #00b0f0;"
          ><span><span lang="en-GB">: </span></span></span
        ><span style="color: #404040;"
          ><span
            ><span lang="en-GB"
              >Revenue/cost/EBITDA target YTD (in &euro;). If reporting timeframe is a previous year: target for the selected year.</span
            ></span
          ></span
        ></span
      >
    </p>
  </li>
  <li>
    <p>
      <span
        ><span style="color: #404040;"><span><span lang="en-GB"><strong>Actual</strong></span></span></span><span style="color: #404040;"
          ><span
            ><span lang="en-GB"
              >: Cumulative actual revenue/costs/EBITDA YTD (in &euro;). If reporting timeframe is a previous year: Actual annual
              revenue/costs/EBITDA of the selected year.</span
            ></span
          ></span
        ></span
      >
    </p>
  </li>
  <li>
    <p>
      <span style="color: #92d050;">●</span><span
        ><span style="color: #404040;"><span><span lang="en-GB">/</span></span></span><span style="color: #ffc000;"
          ><span lang="en-GB"><strong>●</strong></span></span
        ><span style="color: #404040;"><span><span lang="en-GB">: The icon indicates whether the target is met (</span></span></span><span
          style="color: #92d050;"><span lang="en-GB"><strong>●</strong></span></span
        ><span style="color: #404040;"><span><span lang="en-GB">) or missed (</span></span></span><span style="color: #ffc000;"
          ><span lang="en-GB"><strong>●</strong></span></span
        ><span style="color: #404040;"><span><span lang="en-GB">)</span></span></span></span
      >
    </p>
  </li>
</ul>
<p><span><span style="color: #404040;"><span><span lang="en-GB">Chart:</span></span></span></span></p>
<p>
  <span
    ><span style="color: #404040;"
      ><span
        ><span lang="en-GB"
          ><img
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAALCAYAAABCm8wlAAAAF0lEQVR4nGNxjQ/8z4AHsOCTHFVAggIA4psCIYbRm1MAAAAASUVORK5CYII="
            alt=""
          />&nbsp; &nbsp; Half-year revenue</span
        ></span
      ></span
    ></span
  >
</p>
<p>
  <span
    ><span
      ><span
        ><span
          ><img
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAOCAYAAAD9lDaoAAAAP0lEQVR4nGNxjQ/8z87G/p+VlZUBG/j9+zcDCzcn1/8lfbMYgTRWRV+/f/vEglUGDYwqGghF/4H4I5TGBr4AAKSAEP/J+cefAAAAAElFTkSuQmCC"
            alt=""
          />&nbsp; &nbsp; Half-year cost</span
        ></span
      ></span
    ></span
  >
</p>
<p>
  <span
    ><span style="color: #404040;"
      ><span
        ><span lang="en-GB"
          ><img
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAOCAYAAAD9lDaoAAAARElEQVR4nGNxjQ/8z8bK9p+FhZkBG/jz5y8DCycHx/+G4mpGII1V0c9fvz6xYJVBA6OKBkLRf2Ympo9A/B+bAmZGpi8A8fQQs4R2ULgAAAAASUVORK5CYII="
            alt=""
          />&nbsp; &nbsp; Half-year EBITDA</span
        ></span
      ></span
    ></span
  >
</p>
<p>
  <span
    ><span style="color: #404040;"
      ><span
        ><span lang="en-GB"
          ><img
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAALCAYAAABCm8wlAAAAGElEQVR4nGO5efPmfwY8gAWf5KgCEhQAAB9aA7c57FzIAAAAAElFTkSuQmCC"
            alt=""
          />&nbsp; &nbsp; Half-year revenue/cost/EBITDA previous year</span
        ></span
      ></span
    ></span
  >
</p>
<p style="margin-bottom:10px;">
  <span
    ><span style="color: #404040;"
      ><span
        ><span lang="en-GB"
          >(depending on the position of the bar: the bar before the revenue bar shows the revenue of the same half-year the year prior to
          the selected reporting year).</span
        ></span
      ></span
    ></span
  >
</p>

<style>
  p {
    padding: 0;
    margin: 0;
  }

  img {
    width: 11px;
    height: 12px;
  }
</style>
